"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Transform = exports.Type = void 0;
const class_transformer_1 = require("class-transformer");
const JsonUtil_1 = require("../cutil/JsonUtil");
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
function Type(cls, defaultValue = undefined) {
    return Transform((value) => {
        const newModel = JsonUtil_1.JsonUtil.toArrayFromType(cls(), value.value);
        let defaultRealValue = undefined;
        if (typeof defaultValue === "function") {
            defaultRealValue = defaultValue();
        }
        else if (defaultValue === undefined) {
            const Obj = cls();
            defaultRealValue = new Obj();
        }
        else {
            defaultRealValue = (0, cloneDeep_1.default)(defaultValue);
        }
        return (0, is_blank_1.default)(newModel) ? defaultRealValue : newModel;
    });
}
exports.Type = Type;
function Transform(transformFn, options) {
    return (0, class_transformer_1.Transform)(transformFn, options);
}
exports.Transform = Transform;
